import { TimeOperator, UnitsOfTime } from '../data-rules-model';

export class SearchPeriod {
  operatorValue: number;
  timeOperator: TimeOperator;
  unitTime: UnitsOfTime;
}
